import { productService } from '../_services';

const getDefaultState = () => {
  return {
    all: {},
    current: {}
  }
}

export const products = {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    resetState ({ commit }) {
      commit('resetState')
    },
    getAllProducts({ commit }) {
      commit('getAllProductsRequest');
      productService.getAll()
      .then(
          products => commit('getAllProductsSuccess', products),
          error => commit('getAllProductsFailure', error)
      );
    },
    getById({ commit }, productId) {
      commit('getByIdRequest');
      productService.getById(productId)
      .then(
          products => commit('getByIdSuccess', products),
          error => commit('getByIdFailure', error)
      );
    },
    addProduct({ commit }, payload){
      commit('addProductRequest');
      productService.addProduct(payload)
      .then(
        products => commit('addProductSuccess', products),
        error => commit('addProductFailure', error)
      )
    },
    updateProduct({ commit }, payload){
      commit('updateProductRequest');
      productService.updateProduct(payload)
      .then(
        products => commit('updateProductSuccess', products),
        error => commit('updateProductFailure', error)

      )
    }
  },
  mutations: {
    resetState (state) {
      Object.assign(state, getDefaultState())
    },
    getAllProductsRequest(state) {
        state.all = { loading: true };
    },
    getAllProductsSuccess(state, products) {
        state.all = Object.values(products)
    },
    getAllProductsFailure(state, error) {
        state.all = { error };
    },
    getByIdRequest(state) {
        state.current = { loading: true };
    },
    getByIdSuccess(state, product) {
        state.current = product
    },
    getByIdFailure(state, error) {
        state.current = { error };
    },
    addProductRequest(state, product) {
      state.current = product
    },
    addProductSuccess(state, product) {
      if(product.id == state.current.product.id){
        state.current = product;
      }
    },
    addProductFailure(state, error) {
      state.update = { error };
    },
    updateProductRequest(state, product) {
      state.current = product
    },
    updateProductSuccess(state, product) {
      if(product.id == state.current.product.id){
        state.current = product;
      }
    },
    updatProductFailure(state, error) {
      state.update = { error };
    }
  }
}